'use strict';

import type { IndDrug2 } from '../../Entities/Ind/IndDrug2';
import { EntityCollection } from '../EntityCollection';

export class IndDrug2Collection extends EntityCollection<IndDrug2> {}
